import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { Typography, Divider } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import clsx from "clsx";
import { FieldContainer } from "../field";
import { makeStyles } from "@material-ui/core/styles";
import { useThemeProps } from "@ploy-ui/tenants";
import { fieldToKey, sectionToKey } from "../utils";
const useStyles = makeStyles((theme) => ({
    root: {
        position: "relative",
        backgroundColor: "inherit"
    },
    paper: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1)
    },
    header: {
        fontWeight: 700,
        padding: theme.spacing(0.5)
    },
    headerMarginLiteral: {},
    headerSimpleCard: {
        paddingLeft: 12,
        paddingRight: 12,
        paddingTop: 12,
        alignItems: "center",
        display: "flex",
        fontWeight: 400
    },
    outline: ({ outline, square }) => ({
        borderColor: `${(outline && theme.palette[outline] && theme.palette[outline].main) ||
            theme.palette.secondary.main}`,
        borderStyle: "solid"
    }),
    outlineWidth: ({ outlineWidth }) => ({
        borderWidth: outlineWidth
    })
}), { name: "DployFormSection" });
const Section = (props) => {
    const { className, classes = {}, fields = [], sectionTitle, literal, disabled, justifyContent, wrap, onClick, useSeparator, collapsedSection, 
    // showStatus = false,
    // setSectionCompleted,
    formTemplateSectionId, elevation = 0, square, outline, outlineWidth, innerWidthSM, desktopViewForMobile, InnerSectionComponent, headerVariant } = useThemeProps(props, "DployFormSection");
    const sectionClasses = useStyles(props);
    const fieldGroups = fields.reduce((acc, f) => {
        if (f.alignWithPrevious && acc.length > 0) {
            acc[acc.length - 1].push(f);
        }
        else {
            acc.push([f]);
        }
        return acc;
    }, []);
    const defaultVariant = !props.hideSectionIfNoVisibleFields && !fields.some(x => x)
        ? "h5"
        : "body1";
    return (_jsxs(Grid, { component: Paper, elevation: elevation, square: square, container: true, className: clsx(sectionClasses.root, className, {
            [sectionClasses.paper]: elevation > 0 || outline,
            [sectionClasses.outline]: outline,
            [sectionClasses.outlineWidth]: outlineWidth
        }), justifyContent: justifyContent, wrap: wrap, spacing: 1, onClick: onClick, children: [sectionTitle && (_jsx(Grid, { item: true, xs: 12, children: _jsx(Typography, { className: clsx(sectionClasses.header, {
                        [sectionClasses.headerMarginLiteral]: literal ||
                            (fields.some(x => x) && fields.every(field => field.literal)),
                        [sectionClasses.headerSimpleCard]: !props.hideSectionIfNoVisibleFields && !fields.some(x => x)
                    }), variant: headerVariant ?? defaultVariant, children: sectionTitle.replace("_", "\u00A0") }) })), InnerSectionComponent ? (_jsx(InnerSectionComponent, { ...props, className: undefined })) : (fieldGroups.map((fields, idx) => {
                if (fields.length === 0)
                    return null;
                return (_jsx(React.Fragment, { children: _jsx(FieldContainer, { fields: fields, justifyContent: justifyContent, wrap: wrap, literal: literal, lowContrastText: collapsedSection, className: classes.fieldContainer, linkedHelperText: innerWidthSM === "auto" || (innerWidthSM ?? 12) < 12, disabled: disabled, desktopViewForMobile: desktopViewForMobile }, fieldToKey(fields[0])) }, sectionToKey(formTemplateSectionId, idx)));
            })), useSeparator && (_jsx(Grid, { item: true, xs: 12, children: _jsx(Divider, { orientation: "horizontal" }) }))] }));
};
Section.displayName = "DployFormSection";
export default React.memo(Section);
//# sourceMappingURL=Section.js.map